import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ContainerLinkExtractor from './pages/ContainerLinkExtractor';
import ContainerExcelBuilder from './pages/ContainerExcelBuilder';
import GenerateDatatapeFromBoxDataroom from './pages/GenerateDatatapeFromBoxDataroom';
import ContainerDataTapeValidator from './pages/ContainerDataTapeValidator';
import ProjectInquiry from './pages/ProjectInquiry';
import LiqIntel from './pages/LiqIntel';
import LiqIntelGemini from './pages/LiqIntelGemini';
import LiqIntelReport from './pages/LiqIntelReport';
import LiqIntelDelinquency from './pages/LiqIntelDelinquency';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/container-link-extractor" element={<ContainerLinkExtractor />} />
        <Route path="/container-excel-builder" element={<ContainerExcelBuilder />} />
        <Route
          path="/generate-datatape-from-box-dataroom"
          element={<GenerateDatatapeFromBoxDataroom />}
        />
        <Route path="/data-tape-validator" element={<ContainerDataTapeValidator />} />
        <Route path="/project-inquiry" element={<ProjectInquiry />} />
        <Route path="/liqintel" element={<LiqIntel />} />
        <Route path="/liqintel-gemini" element={<LiqIntelGemini />} />
        <Route path="/liqintel-report" element={<LiqIntelReport />} />
        <Route path="/liqintel-delinquency" element={<LiqIntelDelinquency />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
